import { MasterTableDataType as CptType } from "../cptMaster/types";
import { MasterTableDataType as SubDpartmentType } from "../SubDepartmentMasters/types";
export type SearchParamsType = {
  isActive: number;
  searchText: string;
  deptId?: number;
  subDeptId?: number;
};

export type SubDeptSearchParams = {
  isActive: number;
  searchText: string;
  deptId?: number;
};

export type MasterTableDataType = {
  categoryId: number;
  categoryName: string;
  description: string;
  specimenId: number;
  specimenName: string | null;
  subDeptId: number;
  clinicId: number;
  isActive: number;
  subDeptName: string;
  cpt: { cptId: number; cptName: string }[];
};

export type MasterDataType = {
  categoryId: number | null;
  categoryName: string;
  subDeptId: number;
  description: string;
  isActive: number;
  specimenId: number | null;
  clinicId: number;
  cptId: number[];
};

export type SaveResponseType = {};

export type SpecimenType = {
  specimenName: string;
  specimenId: number;
  clinicId: number;
};

export type MasterFormDataType = {
  categoryName: string;
  subDept: SubDpartmentType | null;
  cpt: CptType[] | null;
  specimen: SpecimenType | null;
  description: string;
  isActive: number;
};

export const initialFormData: MasterFormDataType = {
  categoryName: "",
  subDept: null,
  cpt: [],
  specimen: null,
  description: "",
  isActive: 1,
};
